import React, { useState } from 'react';

const ResendEmailVerification = () => {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [isSuccess, setIsSuccess] = useState(null);

    const [formData, setFormData] = useState({
        email: '' // Use "email" here to match the input name
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage(null);
        setIsSuccess(null);

        try {
            const response = await fetch('https://3nrqnhje08.execute-api.us-east-2.amazonaws.com/api/Users/resendEmailVerification', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email: formData.email }),
            });

            const data = await response.json();

            if (response.ok) {
                setMessage(data.message);
                setIsSuccess(data.success); // Display success or error
                if (data.success) {
                    setFormData({ email: '' }); // Clear email input on success
                }
            } else {
                setMessage(data.message || 'An error occurred. Please try again.');
                setIsSuccess(false);
            }
        } catch (err) {
            setMessage('An error occurred. Please try again later.');
            setIsSuccess(false);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="sign-up-vla-container">
            <h2>Resend Email Verification</h2>
            <form onSubmit={handleSubmit}>
                <div className="reset-password-form-group">
                    <label>Email</label>
                    <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required

                    />
                </div>
                {message && (
                    <p
                        className="status-message"
                        style={{ color: isSuccess ? 'green' : 'red' }}
                    >
                        {message}
                    </p>
                )}
                <button type="submit" className="login-create-account-btn" disabled={loading}>
                    {loading ? 'Sending Email Verification Email...' : 'Resend Email Verification Email'}
                </button>
            </form>
        </div>
    );
};

export default ResendEmailVerification;